export default __webpack_public_path__ + "static/media/Shirt10.b3968728.jpeg";